import React from 'react';

const DisplayUnitSettings = ({ unit, setUnit }) => {
  return (
    <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-6 sm:p-8 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V4z" clipRule="evenodd" />
          </svg>
        </div>
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">Unité d'affichage</h2>
      </div>

      <div className="flex bg-gray-50 rounded-xl p-1.5 w-full sm:w-fit">
        <button
          onClick={() => setUnit('m3')}
          className={`flex-1 sm:flex-none px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
            unit === 'm3'
              ? 'bg-white text-teal-600 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Mètres cubes (m³)
        </button>
        <button
          onClick={() => setUnit('litre')}
          className={`flex-1 sm:flex-none px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
            unit === 'litre'
              ? 'bg-white text-teal-600 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Litres (L)
        </button>
      </div>
    </div>
  );
};

export default DisplayUnitSettings;